// removed by extract-text-webpack-plugin
module.exports = {"modal_video":"_3VZiksL3VxlK3Ql1Em4mYQ","content":"_1HLPgtkTC4J099v0XNA9UT","btnMore":"p-t_uQIOtyqRE_0hHUmnP","iframe":"_1t-6qpzEVrO8YhpgUHq2_I","btnCloseModal":"_2y48h5T5I8JO7PQwWk1T4O","three":"_2YD_f_oCttNK4JFFYIcRjx","loader":"_3NhIb7a_CwIN0ZXbXN2ZBg","loader_7":"_3qUmYlqT7o7VRdb0x_j9sb","flip":"_1D7d7JIxYiPReYqGpec2x7"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/patientplaylist/ModalVideo.scss
// module id = 444
// module chunks = 0